// the object is meant to work with 2 URL params
const SELECTION_PARAMS = ['panier=', 'selection='],
      SUCCESS_PARAM = 'success',
      // Référence de commande L'Extension (mail « Nouvelle commande sur votre extension »,
      // lien ?ext=LEXT####&panier=…). Posée en propriété de ligne cachée `_extension_order`
      // → le Carrier Service exempte ces lignes du frais de déconditionnement (stats-ab-plus#368).
      // ⚠️ `ext` doit précéder `panier` dans l'URL (le découpage de `panier=` prend tout ce qui suit).
      EXT_PARAM = 'ext',
      EXT_PROPERTY = '_extension_order',
      extensionOrderRef = (new URLSearchParams(window.location.search).get(EXT_PARAM) || '').trim().slice(0, 40),
      ITEM_SPLIT = '_',
      QTY_SPLIT = 'x',
      queryString = window.location.search,
      itemsContent = document.createElement('div');

let itemsProcessed = 0,
    itemsAdded = 0,
    qtyIssue = false;

class ProductSelection extends HTMLElement {
  constructor() {
    super();
    this.status = this.querySelector('.product-selection__status');
    this.retrievingStatus = this.status.querySelector('.retrieving');
    this.items = this.querySelector('.product-selection__items');
    this.buttonArea = this.querySelector('.product-selection__add');
    this.button = this.querySelector('.add-all-button');
    this.errorMessage = this.querySelector('.add-all-error-message');

    this.validQueryString();
  }

  // check if URL contains a valid param
  validQueryString() {
    if (queryString.includes(SUCCESS_PARAM)) {
      this.displayStatus(tokens.selection_added_success, 'success');
      this.items.classList.add('hidden');
    } else {
      let stringParam = '';
      for (const param of SELECTION_PARAMS) {
        if (queryString.includes(param)) stringParam = param;
      }
      stringParam == '' ? this.displayStatus(tokens.url_issue, 'error') : this.getItems(stringParam)
    };
  }

  // delay function
  delay() {
    return new Promise((resolve) => setTimeout(resolve, 250));
  }

  // query predictive search API
  async querySku(sku, quantity, arrayLength) {
    await this.delay();

    fetch(`${routes.predictive_search_url}?q=${sku}&section_id=predictive-search&resources[options][fields]=variants.sku`)
      .then((response) => {
        if (!response.ok) {
          console.log(response.status);
          itemsProcessed++;
        }
        return response.text();
      })
      .then((text) => {
        const queryContent = new DOMParser().parseFromString(text, 'text/html').querySelector('.predictive-search__results-list li');
        itemsProcessed++;

        if (queryContent != null) {
          if (quantity > 0 && queryContent.querySelector('.quantity__input') != null) {
            const itemQuantity = queryContent.querySelector('.quantity__input'),
                  itemMaxQuantity = parseInt(itemQuantity.getAttribute("max"));
  
            if (quantity > itemMaxQuantity) {
              qtyIssue = true;
              itemQuantity.setAttribute('value', itemMaxQuantity);
              itemQuantity.classList.add('quantity-warning');
            } else {
              itemQuantity.setAttribute('value', quantity);
            }
            itemQuantity.closest('quantity-input').classList.add('no-packing-label');
          }
  
          itemsContent.insertAdjacentHTML('beforeend', queryContent.innerHTML);
          itemsAdded++;
        }

        if (itemsProcessed === arrayLength) {
          this.retrievingStatus.classList.add('hidden');
          this.status.querySelector(itemsAdded > 0 ? '.resolved' : '.no-product').classList.remove('hidden');
          qtyIssue && this.displayStatus(tokens.quantity_issue);
          this.items.classList.remove('loading');
          this.items.innerHTML = itemsContent.innerHTML;
          if (itemsAdded > 0) {
            this.buttonArea.classList.remove('hidden');
            this.initButtonEventListener();
          }
        }
      })
  }

  // get product items contained in URL
  async getItems(stringParam) {
    const items = queryString.split(stringParam)[1].split(ITEM_SPLIT);

    this.retrievingStatus.classList.remove('hidden');

    for (const item of items) {
      let itemSku = item.split(QTY_SPLIT)[0],
          itemQty = item.split(QTY_SPLIT)[1] || 0;

      await this.querySku(itemSku, itemQty, items.length);
    }
  }

  // display status
  displayStatus(content, style) {
    if (typeof style !== "undefined") this.status.classList.add(style);
    this.status.insertAdjacentHTML('beforeend', content);
  }

  // setup add all button click listener
  initButtonEventListener() {
    if (this.button != null) this.button.addEventListener('click', this.addItemsToCart.bind(this));
  }

  // create selection items array
  getSelectionItems() {
    const itemInputs = this.querySelectorAll('.quantity__input'),
          selectionItems = [];

    itemInputs.forEach((input) => {
      const item = {};
      item.id = Number(input.dataset.productSelectedId);
      item.quantity = Number(input.value);
      if (extensionOrderRef) item.properties = { [EXT_PROPERTY]: extensionOrderRef };
      selectionItems.push(item);
    });
    return selectionItems;
  }

  // add items array to cart
  addItemsToCart() {
    const formData = {};

    formData.items = this.getSelectionItems();
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .catch((error) => console.error('Error:', error))
    .then(response => {
      if (response.status) {
        this.errorMessage.innerHTML = response.description;
      } else {
        this.displaySuccessMessage();
      }
    })

  }

  // reload page and display success message
  displaySuccessMessage() {
    let url = window.location.href;    
    if (url.indexOf('?') > -1) {
      url += '&success=true';
    } else {
      url += '?success=true';
    }
    window.location.href = url;
  }
}

customElements.define('product-selection', ProductSelection);
